import React from "react";
import "./FloodgateContainer.css";
import FloodgatePreview from "./FloodgatePreview";
import ColorParse from "../ColorParse";

export default function FloodgateContainer({ config, setConfig, selectedItem }) {
  return (
    <div className="floodgate-container">
      <div className="floodgate-container-top">
        <span className="floodgate-container-title">{ColorParse(config?.title || "Title")}</span>
      </div>
      <div className="floodgate-container-middle">
        <div className="floodgate-container-left" />
        <div className="floodgate-container-content">
          <FloodgatePreview config={config} setConfig={setConfig} selectedItem={selectedItem} />
        </div>
        <div className="floodgate-container-right" />
      </div>
      <div className="floodgate-container-bottom" />
    </div>
  );
}